import buildSimpleStringFilter from '../buildSimpleStringFilter'

const ManufacturerFilter = buildSimpleStringFilter({
  key: 'manufacturer',
  expandedOnInit: false,
})

export default ManufacturerFilter
